














import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class TimestampComponent extends Vue {
  @Prop() value!: any;
  @Prop({ type: String }) label!: string;
  @Prop({ type: String }) type!: any[];
  @Prop({ type: String }) placeholder!: string;

  localValue: any = null

  @Watch('value')
  onValueChange(newVal: any) {
    this.localValue = newVal;
  }

  updateValue(value: any) {
    value = moment(value).utc().local().format('YYYY-MM-DD HH:mm:ss')
    this.onValueChange(value);

    this.$emit('input', value);
  }
}
